import {
  Grid,
  Card,
  Paper,
  CardActions,
  Button,
  CardContent,
  CardHeader,
  FormControlLabel,
  Switch,
  FormControl,
  FormGroup,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { MediaType, DigitalChannelType } from '@nice-ccf/core-sdk';
import {
  CcfBox,
  CcfDatePickerIcon,
  CcfEditIcon,
  CcfTextField,
  CcfTooltip,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import DropDown from './drop-down';
import {
  Contact,
  updateselectedContact,
  updateselectedCustomer,
} from './simulator.slice';
import classes from './simulator.module.scss';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getApplicationLocale } from '@nice-ccf/ui-components';
import dayjs from 'dayjs';
import { useState, useEffect } from 'react';
import Carousel from 'react-material-ui-carousel';
import { useSelector, useDispatch } from 'react-redux';
import EditCustomer from './edit-customer';
import EditCustomerAddress from './edit-customer-address';

/**
 * To show the contact detail for the selected contact from the contact list card. This will also let user to edit the values for the contact detail
 * @param props - it will take selected contact detail, and onchange hadnler
 * @example
 */
const CustomerDetailCard = (props: {
  selectedContact: Contact;
  handleInputChange: any;
  clearSimulatorClicked: any;
  setClearSimulatorClicked: any;
}) => {
  const locale = useSelector(getApplicationLocale);
  const dispatch = useDispatch();
  const {
    selectedContact,
    handleInputChange,
    clearSimulatorClicked,
    setClearSimulatorClicked,
  } = props;
  const [customLabel1, setCustomLabel1] = useState('CXone Expert');
  const [openEditCustomerDialog, setOpenEditCustomerDialog] = useState(false);
  const [openEditCustomerAddressDialog, setOpenEditCustomerAddressDialog] =
    useState(false);
  const [editCustomerDetails, setEditCustomerDetails] = useState(
    JSON.parse(JSON.stringify(selectedContact.customer))
  );
  const [notesData, setNotesData] = useState(
    JSON.parse(JSON.stringify(selectedContact.notes))
  );
  const [customLabel2, setCustomLabel2] = useState('PM SSO');
  const [customLabel3, setCustomLabel3] = useState('Surfly');
  const [customURL1, setcustomURL1] = useState(
    'https://chimericalcorporation.com/expert'
  );
  const [customURL2, setcustomURL2] = useState(
    'https://demo-cxonepm.clearviewportal.com'
  );
  const [setcustomURL3, setsetcustomURL3] = useState(
    'https://surfly-cxone-953a75b368ee.herokuapp.com/'
  );

  useEffect(() => {
    if (clearSimulatorClicked) {
      setCustomLabel1('CXone Expert');
      setcustomURL1('https://chimericalcorporation.com/expert');
      setCustomLabel2('PM SSO');
      setcustomURL2('https://demo-cxonepm.clearviewportal.com');
      setCustomLabel3('Surfly');
      setsetcustomURL3('https://surfly-cxone-953a75b368ee.herokuapp.com/');
      setClearSimulatorClicked(false);
    }
  }, [clearSimulatorClicked]);
  useEffect(() => {
    setNotesData(JSON.parse(JSON.stringify(selectedContact.notes)));
  }, [selectedContact?.notes]);

  useEffect(() => {
    setEditCustomerDetails(
      JSON.parse(JSON.stringify(selectedContact.customer))
    );
  }, [selectedContact?.customer]);

  /**
   * to save custom workspace panel in local storage
   * @param args - none,
   * @example saveCustomWorkspaceHandler()
   */
  const saveCustomWorkspaceHandler = () => {
    let customWorkspacepanel = [
      {
        persistentPanelId: 1,
        persistentPanelLabel: customLabel1,
        persistentPanelURI: customURL1,
      },
    ];
    if (customLabel2.length > 0) {
      customWorkspacepanel = [
        ...customWorkspacepanel,
        {
          persistentPanelId: 2,
          persistentPanelLabel: customLabel2,
          persistentPanelURI: customURL2,
        },
      ];
    }
    if (customLabel3.length > 0) {
      customWorkspacepanel = [
        ...customWorkspacepanel,
        {
          persistentPanelId: 3,
          persistentPanelLabel: customLabel3,
          persistentPanelURI: setcustomURL3,
        },
      ];
    }
    localStorage.setItem(
      'customWorkspacePanel',
      JSON.stringify(customWorkspacepanel)
    );
  };

  /**
   * to make save button disabled or enabled in custom workspace
   * @param args - none,
   * @example isSaveBtnDisabled()
   */
  const isSaveBtnDisabled = () => {
    if (
      customLabel1 &&
      customURL1 &&
      !customLabel2 &&
      !customURL2 &&
      !customLabel3 &&
      !setcustomURL3
    ) {
      return false;
    } else if (
      customLabel1 &&
      customURL1 &&
      customLabel2 &&
      customURL2 &&
      !customLabel3 &&
      !setcustomURL3
    ) {
      return false;
    } else if (
      customLabel1 &&
      customURL1 &&
      customLabel2 &&
      customURL2 &&
      customLabel3 &&
      setcustomURL3
    ) {
      return false;
    } else {
      return true;
    }
  };

  /**@example */
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    label: string
  ) => {
    const editConsumerCardDetails = {
      ...editCustomerDetails,
      [label]: event,
    };
    dispatch(updateselectedCustomer(editConsumerCardDetails));
  };
  /**
   * Used to display date picker icon
   * @example - DatePickerIcon()
   */
  const DatePickerIcon = () => {
    return (
      <CcfBox sx={{ display: 'flex' }}>
        <CcfDatePickerIcon />
      </CcfBox>
    );
  };
  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        <Card>
          <CardHeader title="Customer Details" />
          <CardContent>
            <form
              className={classes.root + ' ' + classes.simulatorForm}
              noValidate
              autoComplete="off"
            >
              <CcfTextField
                className={classes.input}
                id={`sm_customerDetails_customerName`}
                label="Name"
                variant="outlined"
                value={
                  `${[
                    selectedContact.customer?.firstName,
                    selectedContact.customer?.middleName,
                    selectedContact.customer?.lastName,
                  ]
                    .filter(Boolean)
                    .join(' ')}` || ''
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('customerName', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CcfTooltip title={'Edit Customer Details'} arrow>
                        <IconButton
                          onClick={() => {
                            setOpenEditCustomerDialog(true);
                          }}
                        >
                          <CcfEditIcon
                            style={{
                              fontSize: '17px',
                              marginTop: '-31px',
                              marginRight: '-20px',
                            }}
                          />
                        </IconButton>
                      </CcfTooltip>
                    </InputAdornment>
                  ),
                }}
              />
              <CcfTextField
                className={classes.input}
                id="sm_customerDetails_customerAddress"
                label="Address"
                variant="outlined"
                value={
                  selectedContact.customer.customerPrimaryAddress?.address1 +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.address2 +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.city +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.zip +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.state +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.country
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('customerAddress', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CcfTooltip title={'Edit Customer Address'} arrow>
                        <IconButton
                          onClick={() => {
                            setOpenEditCustomerAddressDialog(true);
                          }}
                        >
                          <CcfEditIcon
                            style={{
                              fontSize: '17px',
                              marginTop: '-31px',
                              marginRight: '-20px',
                            }}
                          />
                        </IconButton>
                      </CcfTooltip>
                    </InputAdornment>
                  ),
                }}
              />
              {selectedContact.channel === 'Email' && (
                <>
                  <CcfTextField
                    className={classes.input}
                    id="sm_customerDetails_customerEmailid"
                    label="Email"
                    variant="outlined"
                    value={selectedContact.customer.emailId}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputChange('emailId', event?.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                  <DropDown
                    {...{
                      currentValue:
                        selectedContact.customer.replywithApproval || '',
                      field: 'replywithApproval',
                      label: 'Reply With Approval',
                      options: ['Yes', 'No'],
                      handleInputChange,
                      id: `sm_customerDetails_replywithApproval_${selectedContact.customer.replywithApproval}`,
                      stackName: 'customerDetails_replywithApproval',
                    }}
                  />
                </>
              )}
              <CcfTextField
                className={classes.input}
                id="sm_customerDetails_screenPopURL"
                label="Screen Pop URL"
                variant="outlined"
                value={selectedContact.screenPopURL}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('screenPopURL', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
              />
              <DropDown
                {...{
                  currentValue: selectedContact.screenPopPreference || '',
                  field: 'screenPopPreference',
                  label: 'Screen Pop Preference',
                  options: ['Off', 'New Tab', 'External Window'],
                  handleInputChange,
                  id: `sm_customerDetails_screenPopPreference_${selectedContact.screenPopPreference}`,
                  stackName: 'customerDetails_screenPopPreference',
                }}
              />
              {(selectedContact.media === MediaType.VOICE ||
                selectedContact.channel === DigitalChannelType.CHAT) && (
                <DropDown
                  {...{
                    currentValue: selectedContact.autoSummary || '',
                    field: 'autoSummary',
                    label: 'Auto Summary',
                    options: ['Off', 'On', 'Custom'],
                    handleInputChange,
                    id: `sm_customerDetails_autoSummary_${selectedContact.autoSummary}`,
                    stackName: 'customerDetails_autoSummary',
                  }}
                />
              )}
              {selectedContact.autoSummary === 'Custom' && (
                <>
                  <CcfTypography className={classes.autoSummary_text}>
                    Autosummary Text
                  </CcfTypography>
                  <textarea
                    id="sm_customerDetails_autoSummaryText"
                    className={classes.autoSummary_textarea}
                    defaultValue={
                      'The customer called to request new insurance cards for their daughter, mentioning their employment with the company. The agent confirmed the policy number and offered assistance with ordering the cards. The agent provided information about the delivery timeframe of 10 business days. They also informed the customer about eligibility for a covered annual physical. The issue was resolved successfully.'
                    }
                    value={selectedContact.autoSummaryText}
                    onChange={(event: any) =>
                      handleInputChange('autoSummaryText', event?.target.value)
                    }
                  ></textarea>
                </>
              )}
            </form>
          </CardContent>
        </Card>

        <Card>
          <CardHeader
            style={{ paddingBottom: '0px' }}
            title={`Overview Tab Details`}
          />
          <CardContent style={{ paddingBottom: '0px' }}>
            <CcfBox
              style={{
                height: '480px',
              }}
            >
              <Carousel
                autoPlay={false}
                indicators={true}
                animation="slide"
                navButtonsAlwaysVisible={false}
                className={classes.carousel}
                fullHeightHover={true}
                navButtonsProps={{
                  style: {
                    display: 'none',
                  },
                }}
                navButtonsWrapperProps={{
                  style: {
                    display: 'none',
                  },
                }}
              >
                {notesData?.slice(0, 3).map((note: any, index: any) => (
                  <CcfBox key={index}>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id="sm_overviewTab_notes_title"
                      style={{ marginBottom: '10px', marginTop: '5px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={note.noteTitle}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...notesData];
                        updatedData[index] = {
                          ...updatedData[index],
                          noteTitle: event?.target.value,
                        };

                        setNotesData(updatedData);
                        dispatch(
                          updateselectedContact({
                            field: 'notes',
                            value: updatedData,
                          })
                        );
                      }}
                      label={'Note Title'}
                      variant="outlined"
                    ></CcfTextField>
                    <CcfBox
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                      }}
                    >
                      <CcfTypography style={{ fontSize: '14px' }}>
                        Note Subtitle
                      </CcfTypography>
                      <CcfBox className={classes.editBox}>
                        <textarea
                          id="editNote"
                          name="editNote"
                          style={{ height: '50px' }}
                          className={classes.note_textarea}
                          value={note.subTitle}
                          onChange={(
                            event: React.ChangeEvent<HTMLTextAreaElement>
                          ) => {
                            const updatedData = [...notesData];
                            updatedData[index] = {
                              ...updatedData[index],
                              subTitle: event?.target.value,
                            };

                            setNotesData(updatedData);
                            dispatch(
                              updateselectedContact({
                                field: 'notes',
                                value: updatedData,
                              })
                            );
                          }}
                        ></textarea>
                      </CcfBox>
                    </CcfBox>
                    <CcfBox
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                      }}
                    >
                      <CcfTypography style={{ fontSize: '14px' }}>
                        Note Content
                      </CcfTypography>
                      <CcfBox className={classes.editBox}>
                        <textarea
                          id="editNote"
                          style={{ height: '120px' }}
                          className={classes.note_textarea}
                          value={note.noteContent}
                          onChange={(
                            event: React.ChangeEvent<HTMLTextAreaElement>
                          ) => {
                            const updatedData = [...notesData];
                            updatedData[index] = {
                              ...updatedData[index],
                              noteContent: event?.target.value,
                            };

                            setNotesData(updatedData);
                            dispatch(
                              updateselectedContact({
                                field: 'notes',
                                value: updatedData,
                              })
                            );
                          }}
                        ></textarea>
                      </CcfBox>
                    </CcfBox>
                    <div style={{ marginTop: '10px' }}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={locale}
                        id="sm_overviewTab_date"
                      >
                        <CcfBox data-testid="date-input">
                          <DateTimePicker
                            label="Date"
                            value={dayjs(note.date)}
                            onChange={(event: any) => {
                              const updatedData = [...notesData];
                              updatedData[index] = {
                                ...updatedData[index],
                                date: new Date(event).toISOString(),
                              };

                              setNotesData(updatedData);
                              dispatch(
                                updateselectedContact({
                                  field: 'notes',
                                  value: updatedData,
                                })
                              );
                            }}
                            renderInput={(props: any) => (
                              <CcfTextField
                                fullWidth
                                variant="outlined"
                                color="primary"
                                style={{ marginBottom: '15px' }}
                                className={classes.input}
                                InputProps={{
                                  classes: { input: classes.p10 },
                                }}
                                id="date"
                                InputLabelProps={{ shrink: true }}
                                {...props}
                              />
                            )}
                            components={{
                              OpenPickerIcon: DatePickerIcon,
                            }}
                          />
                        </CcfBox>
                      </LocalizationProvider>
                    </div>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id="sm_overviewTab_agentName"
                      style={{ marginBottom: '15px', marginTop: '5px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={note.agentName}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...notesData];
                        updatedData[index] = {
                          ...updatedData[index],
                          agentName: event?.target.value,
                        };

                        setNotesData(updatedData);
                        dispatch(
                          updateselectedContact({
                            field: 'notes',
                            value: updatedData,
                          })
                        );
                      }}
                      label={'Agent Name'}
                      variant="outlined"
                    ></CcfTextField>
                  </CcfBox>
                ))}
              </Carousel>
            </CcfBox>
          </CardContent>
        </Card>
        <Card style={{ borderRadius: '0px' }}>
          <CardHeader title="Consumer Card Details" />
          <CardContent style={{ paddingTop: '0' }}>
            <CcfBox className={classes.root + ' ' + classes.simulatorForm}>
              <FormControl>
                <FormGroup>
                  <FormControlLabel
                    label="Show External Data Loyalty Card Section"
                    labelPlacement="start"
                    control={
                      <Switch
                        // id="sm_contactDetails_botTranscript"
                        name="Show External Data Loyalty Card Section"
                        color="primary"
                        checked={
                          selectedContact.customer?.externalDataLoyaltyInfoHide
                        }
                        sx={{
                          ' .MuiFormControlLabel-label': {
                            width: 165,
                          },
                        }}
                        onChange={(event: any) =>
                          handleCheckboxChange(
                            event.target.checked,
                            'externalDataLoyaltyInfoHide'
                          )
                        }
                      />
                    }
                    style={{ marginLeft: 0 }}
                    className={classes.label}
                  />{' '}
                  <FormControlLabel
                    label="Show Tickets Tab"
                    labelPlacement="start"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginLeft: 0,
                    }}
                    className={classes.label}
                    control={
                      <Switch
                        // id="sm_contactDetails_botTranscript"
                        name="Show Tickets Tab"
                        color="primary"
                        checked={
                          selectedContact.customer?.consumerCardTicketTabHide
                        }
                        sx={{
                          ' .MuiFormControlLabel-label': {
                            width: 175,
                          },
                        }}
                        onChange={(event: any) =>
                          handleCheckboxChange(
                            event.target.checked,
                            'consumerCardTicketTabHide'
                          )
                        }
                      />
                    }
                  />{' '}
                </FormGroup>
              </FormControl>
            </CcfBox>
          </CardContent>
        </Card>
        <Card className={classes.heightInherit}>
          <CardHeader title="Custom Workspace" />
          <CardContent>
            <form
              className={classes.root + ' ' + classes.simulatorForm}
              noValidate
              autoComplete="off"
            >
              <CcfTextField
                id="sm_customWorkspace_Label1"
                className={classes.input}
                label="Label 1"
                variant="outlined"
                value={customLabel1}
                onChange={(e: any) => setCustomLabel1(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Url1"
                className={classes.input}
                label="URL 1"
                variant="outlined"
                value={customURL1}
                onChange={(e: any) => setcustomURL1(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Label2"
                className={classes.input}
                label="Label 2"
                variant="outlined"
                value={customLabel2}
                onChange={(e: any) => setCustomLabel2(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Url2"
                className={classes.input}
                label="URL 2"
                variant="outlined"
                value={customURL2}
                onChange={(e: any) => setcustomURL2(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Label3"
                className={classes.input}
                label="Label 3"
                variant="outlined"
                value={customLabel3}
                onChange={(e: any) => setCustomLabel3(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Url3"
                className={classes.input}
                label="URL 3"
                variant="outlined"
                value={setcustomURL3}
                onChange={(e: any) => setsetcustomURL3(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </form>
          </CardContent>
          <CardActions className={classes.simulatorSaveButton}>
            <Button
              id="sm_customWorkspace_save"
              size="large"
              variant="contained"
              color="primary"
              onClick={saveCustomWorkspaceHandler}
              disabled={isSaveBtnDisabled()}
            >
              Save
            </Button>
          </CardActions>
        </Card>
      </Paper>
      <EditCustomer
        openEditCustomerDialog={openEditCustomerDialog}
        setOpenEditCustomerDialog={setOpenEditCustomerDialog}
        selectedContact={selectedContact}
        editCustomerDetails={editCustomerDetails}
        setEditCustomerDetails={setEditCustomerDetails}
      />

      <EditCustomerAddress
        openEditCustomerAddressDialog={openEditCustomerAddressDialog}
        setOpenEditCustomerAddressDialog={setOpenEditCustomerAddressDialog}
        selectedContact={selectedContact}
        editCustomerDetails={editCustomerDetails}
        setEditCustomerDetails={setEditCustomerDetails}
      />
    </Grid>
  );
};

export default CustomerDetailCard;
